
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('.outlet-add-to-cart');
    if (!button) return;

    const variantId = button.dataset.variantId;

    const originalTextContent = button.textContent;

    button.disabled = true;
    button.textContent = 'Adding...';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      });

      if (!response.ok) {
        throw new Error('Add to cart failed');
      }

      const item = await response.json();

      button.textContent = 'Added ✓';

      document.dispatchEvent(new CustomEvent('cart:refresh', {
        detail: {
          open: true,
        },
      }));

    } catch (error) {
      console.error(error);
      button.textContent = 'Failed';
    }

    setTimeout(() => {
      button.disabled = false;
      button.textContent = originalTextContent;
    }, 1500);
  });

  document.addEventListener('click', function (e) {

    const link = e.target.closest('.toggle-outlet-explainer');
    if (!link) return;

    e.preventDefault();

    const explainer = link.closest('.outlet-explainer-container').querySelector('.outlet-explainer');
    explainer.classList.toggle('is-open');

  });